import { Component, Input } from '@angular/core';
import { NotificationType } from '@app/shared/interfaces/lib/notification.interface';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  selector: 'sbnb-direct-domain-description',
  templateUrl: './direct-domain-description.component.html',
  styleUrl: './direct-domain-description.component.scss',
})
export class DirectDomainDescriptionComponent {
  @Input() isPublished: boolean;
  @Input() url: string;

  constructor(private toast: ToastNotificationsService) {}

  copiedToClipboard() {
    this.toast.open('Copied to clipboard', 'Dismiss', NotificationType.Success, 2500);
  }
}
